<template>
  <b-row align-v="start" no-gutters>
    <b-col cols="9">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-testid="'basket-tracker-subscription-name-message'">{{ productName }}</p>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="productDescription" v-html="productDescription"></div>
    </b-col>
    <b-col>
      <h3 class="my-0 text-right">
        <span :style="{ textDecoration: Number(item.subtotal) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }">
          {{ $n(item.subtotal, 'currency') }}
        </span>
        <span v-if="Number(item.subtotal) !== Number(item.subtotal - item.discount)" class="ml-1">
          <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
          <span v-else>{{ $t('components.totals.free') }}</span>
        </span>
      </h3>
    </b-col>
  </b-row>
</template>

<script>
import { getImage } from '@/utils';

export default {
  name: 'PetTrackingDeviceSubscriptionProduct',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    homeSafeFormattedProductName() {
      return this.productName.replaceAll('HomeSafe', 'Home<span class="font-italic">Safe</span>').replaceAll('®', '<sup>&reg;</sup>');
    },
    productDescription() {
      return this.item.product.description;
    },
    orderItemId() {
      return this.item.id;
    },
    productName() {
      return this.item.product.name;
    },
  },
  methods: {
    getImage,
  },
};
</script>

<style scoped></style>
